// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SendMessageButton_button__Xvv3k {
  height: 40px;
  display: inline-flex;
  align-items: center;
  border: 0;
  background: transparent;
  cursor: pointer;
  padding-right: 15px;
  padding-left: 10px;
}
.SendMessageButton_buttonDisabled__-31Y\\+ {
  cursor: not-allowed;
}
.SendMessageButton_buttonDisabled__-31Y\\+ .SendMessageButton_icon__fW9KG {
  opacity: 0.54;
}

.SendMessageButton_icon__fW9KG {
  transition: 0.2s all;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/ChatBottomPanels/NewMessagePanel/SendMessageButton/SendMessageButton.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EAEA,mBAAA;EACA,kBAAA;AAAF;AAEE;EACE,mBAAA;AAAJ;AAEI;EACE,aAAA;AAAN;;AAKA;EACE,oBAAA;AAFF","sourcesContent":[".button {\n  height: 40px;\n  display: inline-flex;\n  align-items: center;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n\n  padding-right: 15px;\n  padding-left: 10px;\n\n  &Disabled {\n    cursor: not-allowed;\n\n    .icon {\n      opacity: 0.54;\n    }\n  }\n}\n\n.icon {\n  transition: 0.2s all;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `SendMessageButton_button__Xvv3k`,
	"buttonDisabled": `SendMessageButton_buttonDisabled__-31Y+`,
	"icon": `SendMessageButton_icon__fW9KG`
};
export default ___CSS_LOADER_EXPORT___;
